import React, { Component } from 'react'
import Slide from '../Globals/Slide/slide'
import './estilo.css'


class SeleccionRango extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    mensual = () =>{
        let url='/nuevoViaje/';
        this.props.history.push(url);
    }

    semanal = ()=>{
        let url='adicciones';
        this.props.history.push(url);
    }
    
    diaria = () =>{
        let url='/cargaemple';
        this.props.history.push(url);
    }

    render() {
        return (
            <div>
                <Slide />
                <div className='borde'>
                    <div className="row">
                        <aside className="col-sm-6" onClick={this.mensual}>
                            <div className="card-banner  overlay-grad" style={{ height: 250 }}>
                                <div className="card-body text-white">
                                    <h5 className="titulos">Programación Mensual</h5>
                                    <p className="card-text">Planifica/comprueba la progracion de taxis del siguiente mes</p>
                                </div>
                            </div>
                        </aside>
                        <aside className="col-sm-6" onClick={this.diaria}>
                            <div className="card-banner  overlay-grad3" style={{ height: 250 }}>
                                <div className="card-body text-white">
                                    <h5 className="card-title">Programación Diaria</h5>
                                    <p className="card-text">Planifica/comprueba la progracion de taxis del siguiente dia</p>
                                </div>
                            </div>
                        </aside>              
                    </div>
                    <br/>
                    <div className="row">
                        <aside className="col-sm-6" onClick={this.semanal}>
                                <div className="card-banner  overlay-grad2" style={{ height: 250 }}>
                                    <div className="card-body text-white">
                                        <h5 className="card-title">Adiciones a progracion</h5>
                                        <p className="card-text">Tramites documentales, modificacion, adicion y cancelacion de viajes</p>
                                    </div>
                                </div>
                        </aside>
                    </div>
                </div>
            </div>

        )
    }
}
export default SeleccionRango;


// WEBPACK FOOTER //
// ./src/Components/Programacion/selecionRango.js